import React, { forwardRef, useImperativeHandle, useRef } from "react";
import OverviewForm from "../Forms/OverviewForm";
import DescriptionForm from "../Forms/DescriptionForm";
import WorkExperienceForm from "../Forms/WorkExperienceForm";
import DocumentsForm from "../Forms/DocumentsForm";
import QualificationForm from "../Forms/QualificationForm";
import useAuth from "../../../hooks/useAuth";
import { UserType } from "../../../utils/enum";
import { combineValidationResults } from "../../../utils/formErrors";

const Summary = forwardRef((props, ref) => {
  const { authRole } = useAuth();
  const isCustomer = authRole === UserType.CUSTOMER;
  const overviewRef = useRef();
  const workExperienceRef = useRef();
  const workOrderEligibilityRef = useRef();
  useImperativeHandle(ref, () => ({
    // Must combine rather than `&&` the results: each isValid() returns a
    // { valid, errors } object, so chaining them with && would keep only the
    // last object and silently drop every other form's errors.
    // Listed in the order the cards appear, so the reported count and the
    // first-error focus line up with what the user sees.
    isValid: () =>
      combineValidationResults(
        overviewRef.current?.isValid?.(),
        workOrderEligibilityRef.current?.isValid?.(),
        // Work Experience is hidden for customers, so don't gate on its validation.
        ...(isCustomer ? [] : [workExperienceRef.current?.isValid?.()]),
      ),
  }));
  return (
    <div>
      <OverviewForm ref={overviewRef} />
      <DescriptionForm />
      <QualificationForm ref={workOrderEligibilityRef} />
      {!isCustomer && <WorkExperienceForm ref={workExperienceRef} />}
      <DocumentsForm />
    </div>
  );
});

export default Summary;
